import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OwnService } from '../../services/owners/own.service';
import { ListService } from '../../list.service';


import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'mcrit-gestio-owners-filters',
  templateUrl: 'owners-filters.component.html',
  styleUrls: ['owners-filters.component.css'],
  providers: [OwnService, ListService]
})

export class OwnFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(private listOwnService: ListService,private ownService: OwnService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listOwnService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listOwnService.valFiltres[key] = this.filterModel[key]);
    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listOwnService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    const newFilter = {};
    if(this.filterModel.length > -1)
        for (let key of this.filterModel) { newFilter[key] = null; }
    this.listOwnService.valFiltres={};
    this.filterModel = newFilter;
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
      if(!this.validFilters) return;
      this.filterModel = this.validFilters.reduce((acum, curr) => {
          curr.inputs.forEach(inputGroup => {
            switch (inputGroup.type) {
              case 'select':
                acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
                break;
              default:
              inputGroup.values.forEach(input => {
                if (input.autocomplete) {
                  requestedAutocompletes.push(input.autocomplete);
                }
                acum[input.name] = (input.value ? input.value : null);
              });
            }
          });
        return acum;
      }, {});

      this.dataLists = requestedAutocompletes.map(id => {
        return {
          id: id,
          options: this.ownService.getAutocomplete(id)
        };
      });
    this.sendActiveFilters();
  }
}
